<template>
  <a
    href="#"
    :class="$style.container"
    @click.prevent="containerClickHandler"
  >
    <img
      src="~@images/burger.svg"
      alt=""
      :class="$style.burgerIcon"
      width="22"
      height="16"
    >
  </a>
</template>

<script>
  import { EVENT_BURGER_MENU_CLICK } from '@events/Toolbar'

  export default {
    methods: {
      containerClickHandler (e) {
        this.$sendSystemEvent(EVENT_BURGER_MENU_CLICK)
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins";

  /**
   * Container
   */
  .container {
    display: flex;
    align-items: center;
    padding: 0px 15px;
  }

  /**
   * Burger icon
   */
  .burgerIcon {
    width: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BurgerMenu.vue